import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SoPoStateModule } from './state/app.state.module';
import { SoPoFirebaseModule } from './firebase/firebase.module';

/**
 * The Core Module imports module that is necessary for the SOPO app to operate.
 */
@NgModule({
    imports: [
        CommonModule,
        SoPoFirebaseModule,
        SoPoStateModule,
        SharedModule,
    ],
    declarations: [],
    exports: [
        SoPoStateModule,
        SoPoFirebaseModule,
    ],
})
export class SoPoCoreModule {}
